(function($) {

	//
	$(document).ready(function() {
		//
		var $body = $('body');
		var lastScrollPosition = 0;

		$(window).on('scroll', function() {
			//
			var $headerElement = $('#site-header');

			//
			var scrollPosition = $(this).scrollTop();
			var pageWidth = $(this).width();
			var scrollDown = scrollPosition > lastScrollPosition;
			var headerHeight = $headerElement.height();
			var adminBar = $('#wpadminbar');
			var adminBarHeight = (adminBar.height() ? adminBar.height() : 0) + 0;
			var scrollPastTop = (scrollPosition > (headerHeight + adminBarHeight));
			var currentHeaderTop = parseInt($headerElement.css('top'));

			// console.log({
			// 	scrollPosition: scrollPosition,
			// 	pageWidth: pageWidth,
			// 	scrollDown: scrollDown,
			// 	headerHeight: headerHeight,
			// 	adminBarHeight: adminBarHeight,
			// 	scrollPastTop: scrollPastTop,
			// 	currentHeaderTop: currentHeaderTop,
			// });

			//
			if(scrollPosition > headerHeight) {
				//
				$headerElement.addClass('animate-top');

				//
				if(!scrollDown) {
					if(pageWidth > 600) {
						$headerElement.css({top: adminBarHeight});
					} else {
						if(scrollPosition > adminBarHeight) {
							$headerElement.css({top: 0});
						} else {
							$headerElement.css({top: adminBarHeight - scrollPosition});
						}
					}
				} else {
					if(pageWidth > 600) {
						$headerElement.css({top: adminBarHeight - Math.min(scrollPosition, headerHeight)});
					} else {
						$headerElement.css({top: -Math.min(scrollPosition, headerHeight)});
					}
				}
			} else {
				$headerElement.css({top: adminBarHeight});
			}

			lastScrollPosition = scrollPosition;
		});
	})
})(window.jQuery);
